import { ProductModelType } from '@/models/api';
import _ from 'lodash';

export const validateOrderPlan = (orderPlan: any, productsLookup: Record<string, ProductModelType>): boolean => {
  return _.every(orderPlan.lineItems, lineItem => {
    return productsLookup[lineItem.sku as string]
  })
}